import React, { useState } from "react";
import { ApiService, ImgUrl, addDefaultSrc } from "../services";
import { TableContainer } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import {
  Table,
  TableBody,
  TableRow,
  TableRowData,
  TableHead,
  TableHeader,
} from "../styledComponents/tableStyle";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import GButton from "../gComponents/gButton";
import OfferPopUpForm from "../forms/offerPopUpForm";
import { useSnackbar } from "react-simple-snackbar";
import useDataFctory from "../useDataFactory";
import GText from "../gComponents/gText";
import Modal from "react-modal";
import GLightBox from "../gComponents/gLightBox";
import moment from "moment-timezone";

const columns = [
  { id: "image", label: "Image", minWidth: 70 },
  { id: "type", label: "Type", minWidth: 90, align: "center" },
  { id: "title", label: "Title", minWidth: 120, align: "center" },
  { id: "value", label: "Value", minWidth: 100, align: "center" },
  { id: "time_schedule", label: "Time Schedule", minWidth: 150 },
  { id: "actions", label: "Actions", minWidth: 80, align: "center" },
];

export default function OfferPopUps(props) {
  const [openSnackbar] = useSnackbar();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedPopupData, setSelectedPopupData] = useState({});
  const [selectedPopupId, setSelectedPopupId] = useState("");
  const [oPopupVisible, setOPopupVisible] = React.useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [selectedImgPreview, setSelectedImgPreview] = useState(false);
  const [isImgPreview, setImgPreview] = useState(false);
  const {
    loading,
    data: popupsData,
    Placeholder,
    TableShimmer,
  } = useDataFctory("popups", false);

  const deletePopup = () => {
    ApiService({ method: "DELETE", route: "popups/" + selectedPopupId })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          let selectedIndex = popupsData.findIndex(
            (p) => p.id == selectedPopupId
          );
          if (selectedIndex > -1) {
            popupsData.splice(selectedIndex, 1);
          }
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="rightInnerView">
      <GButton
        variant="condensed"
        children="Add"
        onClick={() => {
          setSelectedPopupData({});
          setIsEmpty(true);
          setOPopupVisible(true);
        }}
        style={{
          float: "right",
        }}
      />
      <GText g2 bold text={"Offer Pop-Ups"} style={{ marginBottom: "15px" }} />
      <div className="listPaper">
        {loading === true ? (
          <TableShimmer />
        ) : popupsData.length === 0 ? (
          <Placeholder />
        ) : (
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableHeader
                      key={column.id}
                      style={{
                        minWidth: column.minWidth,
                        textAlign: column.align,
                      }}
                    >
                      {column.label}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {popupsData.map((c) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={c.id}>
                      <TableRowData
                        style={{ BorderBottom: "1px solid #f4f5f9" }}
                      >
                        <img
                          alt=""
                          src={ImgUrl("popup") + "/" + c.image}
                          onError={addDefaultSrc}
                          className="thumbnail"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedImgPreview(c.image);
                            setImgPreview(true);
                          }}
                        />
                      </TableRowData>
                      <TableRowData
                        style={{
                          textAlign: "center",
                          textTransform: "capitalize",
                        }}
                      >
                        {c.type}
                      </TableRowData>
                      <TableRowData style={{ textAlign: "center" }}>
                        {c.title || "-"}
                      </TableRowData>{" "}
                      <TableRowData style={{ textAlign: "center" }}>
                        {c.value || "-"}
                      </TableRowData>
                      <TableRowData>
                        Valid From :{" "}
                        {c.starts ? (
                          moment(new Date(c.starts)).format(
                            "DD MMM, yyyy HH:mm A"
                          )
                        ) : (
                          <span style={{ color: "#a2a2a2" }}>NA</span>
                        )}
                        <br />
                        Valid Upto :{" "}
                        {c.ends ? (
                          moment(new Date(c.ends)).format(
                            "DD MMM, yyyy HH:mm A"
                          )
                        ) : (
                          <span style={{ color: "#a2a2a2" }}>NA</span>
                        )}
                      </TableRowData>
                      <TableRowData
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <GButton
                          variant="linkable"
                          onClick={(e) => {
                            setSelectedPopupData(c);
                            setIsEmpty(false);
                            setOPopupVisible(true);
                          }}
                        >
                          <Edit fontSize="small" />
                        </GButton>

                        <GButton
                          variant="linkable"
                          onClick={(e) => {
                            setSelectedPopupId(c.id);
                            setDialogOpen(true);
                          }}
                        >
                          <Delete fontSize="small" />
                        </GButton>
                      </TableRowData>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>

      {isImgPreview === true && (
        <GLightBox
          images={selectedImgPreview}
          isImgPreview={isImgPreview}
          setImgPreview={setImgPreview}
          imgType="popup"
        ></GLightBox>
      )}

      {dialogOpen === true && (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Offer Pop-Up"
          text="Are you sure you want to delete this Offer Pop-Up?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
            deletePopup();
          }}
        ></GConfirmDialog>
      )}

      <Modal
        isOpen={oPopupVisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setOPopupVisible(false)}
        style={{
          content: {
            width: "470px",
          },
        }}
        contentLabel="Offer Pop-Up Form Modal"
      >
        <OfferPopUpForm
          oPopupVisible={oPopupVisible}
          setOPopupVisible={setOPopupVisible}
          data={selectedPopupData}
          isEmpty={isEmpty}
          onSubmit={(data) => {
            let selectedIndex = popupsData.findIndex((p) => p.id == data.id);
            if (selectedIndex > -1) {
              popupsData[selectedIndex] = { ...data };
            } else {
              popupsData.push(data);
            }
          }}
        />
      </Modal>
    </div>
  );
}
